/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export enum ErrorCode {
	Required = 'required',
	Unique = 'unique',
	MinLength = 'minimum length',
	MaxLength = 'maximum length',
	Minimum = 'minimum',
	Maximum = 'maximum',
	Pattern = 'pattern',
	Enum = 'enum',
}
